module.exports = __webpack_public_path__ + "img/domain-c.409b389.409b389.svg";